// extracted by mini-css-extract-plugin
module.exports = {"main":"App_main__15v7H","contentWrapper":"App_contentWrapper__3KVMM"};